import { invokeWithSessionRetry } from "@/lib/invoke-with-session-retry";
import { toFunctionErrorMessage } from "@/lib/ai-client-common";
import type {
  SaveStudyPlanCheckinPayload,
  SaveStudyPlanCheckinResponse,
  SaveStudyPlanPayload,
  SaveStudyPlanResponse,
} from "@/types/study-plan";

export async function requestSaveStudyPlan(payload: SaveStudyPlanPayload): Promise<SaveStudyPlanResponse> {
  const { data, error } = await invokeWithSessionRetry<SaveStudyPlanResponse>("save-study-plan", {
    body: payload,
  });
  if (error || !data) {
    throw new Error(await toFunctionErrorMessage(error, "Failed to save study plan"));
  }
  return data as SaveStudyPlanResponse;
}

export async function requestSaveStudyPlanCheckin(
  payload: SaveStudyPlanCheckinPayload,
): Promise<SaveStudyPlanCheckinResponse> {
  const { data, error } = await invokeWithSessionRetry<SaveStudyPlanCheckinResponse>("save-study-plan-checkin", {
    body: {
      plan_id: payload.planId,
      summary: payload.summary,
      checkin_type: payload.checkinType,
      status: payload.status,
      next_action: payload.nextAction ?? null,
    },
  });
  if (error || !data) {
    throw new Error(await toFunctionErrorMessage(error, "Failed to save study plan check-in"));
  }
  return data as SaveStudyPlanCheckinResponse;
}
